import { RootState } from "../../../utils/types/root-state";


export const getBurgerConstructorState = (state: RootState) => state.burgerConstructor;